import React, { ReactNode } from 'react';
import { panelThemeFactory } from 'styles/themes/panelTheme';
import { useStyles } from 'components/shared/layout/Main/Main.styles';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import { Theme } from '@mui/material';
import classNames from 'classnames';

interface MainProps {
  className?: string;
  children?: ReactNode;
}

export const Main: React.FC<MainProps> = (props) => {
  const classes = useStyles();

  return (
    <main className={classNames(classes.main, props.className)}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={(outerTheme: Theme) => panelThemeFactory(outerTheme)}>
          <div className={classes.toolbar} />
          {props.children}
        </ThemeProvider>
      </StyledEngineProvider>
    </main>
  );
};
